import React from 'react';
import { DialogTitle, IconButton, Stack, Typography } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { StudentAvatar } from '@/components/StudentAvatar';
import { Student } from '@/types';

interface DialogHeaderProps {
  student: Student;
  onClose: () => void;
  isNew?: boolean;
}

export const DialogHeader: React.FC<DialogHeaderProps> = ({
  student,
  onClose,
  isNew = false
}) => {
  return (
    <DialogTitle>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Stack direction="row" spacing={2} alignItems="center">
          {!isNew && (
            <StudentAvatar
              student={student}
              sx={{ width: 40, height: 40 }}
            />
          )}
          <Typography variant="h6">
            {isNew ? 'Add New Student' : `${student.firstName} ${student.lastName}`}
          </Typography>
        </Stack>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </Stack>
    </DialogTitle>
  );
};